import React, {useState,useEffect} from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axiosInstance from "../../server/axios";

 const VisitlogCreate = () => {
    useEffect(()=>{
    },[]);

    const [value, setValue] = useState("");
    
    const getUserData = () => {
        //const UserData = axiosInstance.get();
    }
    const modules = {
        toolbar: [
          [{ header: [1, 2, false] }],   // 제목
          ["bold", "italic", "underline", "strike"], 
          [{ list: "ordered" }, { list: "bullet" }],
          ["link", "image"],             // 링크, 이미지
          ["clean"],                     // 서식 제거
        ],
      };
    const formats = [
        "header", "bold", "italic", "underline", "strike",
        "list", "bullet", "link", "image"
    ];
    return(
    <div>
        <ReactQuill 
        theme="snow" 
        value={value} 
        onChange={setValue} 
        modules={modules} 
        formats={formats}
        />
    <pre>{value}</pre>    {/* 저장된 HTML 확인 */}
    </div>
    )
}

export default VisitlogCreate;